import React, { useEffect, useState } from 'react'

export default function LockedProfile({isManager, teamName}) {
    const [showModal, setShowModal] = useState(true)
    const [displayMessage, setDisplayMessage] = useState('')

    useEffect(() => {
        if (isManager) {
            setDisplayMessage(`
                This profile has been locked because you have exceeded your profile limit and as a result you cannot edit
                this profile, create new post or invoices. We ecourage you to upgrade your plan or purchase additional profiles
            `)
        } else {
            setDisplayMessage(`
                Your profile has been locked because ${teamName} have exceeded their profile limit and as a result your access to
                certain features like messages have been limited, contact ${teamName} to get your account unlocked
            `)
        }
    }, [])

  return (
    <div>
        {showModal &&
            <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                <div className="bg-white mx-auto rounded shadow p-5 text-center">
                    <h4>Important Information</h4>
                    <p>
                        {displayMessage}
                    </p>

                    <div className="pt-3">
                        <button onClick={() => setShowModal(false)} type="button" className="btn btn-primary mr-2">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        }
    </div>
  )
}
